;
define("cart_add_to_cart_button.tpl", function(){});

